export default "<img [src]=\"urlMonikerImage\">";